import { Turret } from "../Turret";
import { Engine } from "../../Engine";
import { MathUtils } from "../../utils/MathUtils";

export class Mortar {

    public id: number;
    public x: number;
    public y: number;
    public ticksToImpact: number;
    public detonate: boolean;
    public creationTick: number;
    public turret: Turret;
    public explosionRange: number;
    public damage: number;

    private vx: number;
    private vy: number;
    private f: number;
    
    private engine: Engine;
    
    // mortar speed in cells / tick
    constructor (p: {r: number, c: number}, angle: number, ticksToImpact: number, explosionRange: number, damage: number, turret: Turret, engine: Engine) {
        
        this.id = engine.mortarId;
        engine.mortarId ++;

        this.creationTick = engine.ticksCounter;

        this.x = p.c + .5;
        this.y = p.r + .5;

        this.ticksToImpact = ticksToImpact;
        this.explosionRange = explosionRange;
        this.damage = damage;
        this.turret = turret;
        this.engine = engine;

        this.detonate = false;
        this.f = 0;

        this.vx = MathUtils.fixNumber(this.turret.projectileSpeed * Math.cos(angle));
        this.vy = MathUtils.fixNumber(this.turret.projectileSpeed * Math.sin(angle));
    }

    public destroy(): void {
        //
    }

    public update(): void {
        
        this.x = MathUtils.fixNumber(this.x + this.vx);
        this.y = MathUtils.fixNumber(this.y + this.vy);

        this.f ++;

        if (this.f === this.ticksToImpact) {
            this.detonate = true;
        }
    }
}
